import styled from 'styled-components';

const Container = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const Box = styled.div`
  padding: 20px;
`;
const WizardFooter = styled.div`
  height: 30px;
  background-color: rgb(32, 144, 136);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 10px;
  color: white !important;
  margin: 0;
  position: fixed;
  bottom: 0;
  width: 100%;
`;

const Img = styled.img`
  width: 8px;
  height: 15px;
  margin-right: 10px;
`;

const Link = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  text-decoration: none;
  border: 2px solid #2563eb;
  border-radius: 8px;
  outline-style: none;
  position: absolute;
  top: -65px;
  right: 40px;
  margin-top: 80px;
  background-color: #2563eb;
  color: #fff;
  transition: all 0.2s ease;

  svg {
    fill: #fff;
    color: #fff;
  }

  &:hover {
    background-color: #1d4ed8;
    border-color: #1d4ed8;
    cursor: pointer;
  }

  @media (max-width: 480px) {
    display: none;
  }
`;

const WizardContent = styled.div`
  height: 100%;
  width: 100%;
  padding: 0px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  form {
    width: 100%;
    display: flex;
    padding-top: 0px;
    justify-content: center;
    align-items: center;
    flex-direction: column;
  }
`;

export { Container, Box, WizardFooter, Img, WizardContent, Link };
